import { HttpContext, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PoComboOption, PoDialogService, PoNotificationService, PoSelectOption } from '@po-ui/ng-components';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class UtilService {

  constructor(
    private poNotificationService: PoNotificationService,
    private poDialogService: PoDialogService,
  ) {}

  getListaEstados(): Array<PoSelectOption> {
      return [
    { value: 'AC', label: 'ACRE' },
    { value: 'AL', label: 'ALAGOAS' },
    { value: 'AM', label: 'AMAZONAS' },
    { value: 'AP', label: 'AMAPA' },
    { value: 'BA', label: 'BAHIA' },
    { value: 'CE', label: 'CEARA' },
    { value: 'DF', label: 'DISTRITO FEDERAL' },
    { value: 'ES', label: 'ESPIRITO SANTO' },
    { value: 'EX', label: 'ESTRANGEIRO' },
    { value: 'GO', label: 'GOIAS' },
    { value: 'MA', label: 'MARANHAO' },
    { value: 'MG', label: 'MINAS GERAIS' },
    { value: 'MS', label: 'MATO GROSSO DO SUL' },
    { value: 'MT', label: 'MATO GROSSO' },
    { value: 'PA', label: 'PARA' },
    { value: 'PB', label: 'PARAIBA' },
    { value: 'PE', label: 'PERNAMBUCO' },
    { value: 'PI', label: 'PIAUI' },
    { value: 'PR', label: 'PARANA' },
    { value: 'RJ', label: 'RIO DE JANEIRO' },
    { value: 'RN', label: 'RIO GRANDE DO NORTE' },
    { value: 'RO', label: 'RONDONIA' },
    { value: 'RR', label: 'RORAIMA' },
    { value: 'RS', label: 'RIO GRANDE DO SUL' },
    { value: 'SC', label: 'SANTA CATARINA' },
    { value: 'SE', label: 'SERGIPE' },
    { value: 'SP', label: 'SAO PAULO' },
    { value: 'TO', label: 'TOCANTINS' }
      ];
  }

  formatarCGC(cgc: string){

    const cgcRetornar = cgc.replace(/[.\-\/]/g, '').toUpperCase();

    if (cgcRetornar.length === 11){
      return cgcRetornar.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else {
      return cgcRetornar.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }
  }

  formatarCEP(cep: string) {
    return cep.replace(/(\d{2})(\d{3})(\d{3})/g, '$1.$2-$3');
  }

  getUniqueId(parts: number): string {
    const stringArr = [];
    for (let i = 0; i < parts; i++) {
      // eslint-disable-next-line no-bitwise
      const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      stringArr.push(S4);
    }
    return stringArr.join('-');
  }

  round(num: number, places: number) : number {
    const factorOfTen = Math.pow(10,places);
    return Math.round(num * factorOfTen) / factorOfTen;
  }

  /*{
  headers?: HttpHeaders | {
    [header: string]: string | string[];
  };
  context?: HttpContext;
  observe?: 'body';
  params?: HttpParams | {
    [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
  }
  },*/

  filtrosHttpOptions(filtro: any = {}, showMensagemRetorno: boolean = true ,showQuery: boolean = false): {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    context?: HttpContext;
    observe?: 'body';
    responseType?: 'json';
    params?: HttpParams | {
      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    }
   }{

    const httpOptions = {
      headers: new HttpHeaders(
        {
          'X-PO-Screen-Lock': 'true',
          'X-PO-No-Message': (showMensagemRetorno?'false':'true'),
        }
      ),

      params: new HttpParams(),
    };

    if(filtro){
      Object.keys(filtro).some(key => {

        if ((filtro[key] || filtro[key] === 0) && key.toUpperCase() !== 'LASTSETDEFAULT'){

          if ((filtro[key] instanceof Object)) {

            if (key.substring(0,6) === "deate_"){
              if (key){
                if (filtro[key].start){
                  httpOptions.params = httpOptions.params.append(`${key.substring(6,100)}_de`, filtro[key].start)  ;
                }
                if (filtro[key].end){
                  httpOptions.params = httpOptions.params.append(`${key.substring(6,100)}_ate`, filtro[key].end)  ;
                }
              }
            } else if (Array.isArray(filtro[key])){
              httpOptions.params = httpOptions.params.append(key, filtro[key].join())  ;
            }else{
              try {
                httpOptions.params = httpOptions.params.append(key , new Date(filtro[key]).toISOString().substring(0,10));
               } catch {
                httpOptions.params = httpOptions.params.append(key, filtro[key].toString());
              }
            }
          } else {
            httpOptions.params = httpOptions.params.append(key, filtro[key].toString());
          }
        }
      });
    }
    if (showQuery){
      httpOptions.params = httpOptions.params.append('SHOWQUERY', 'S');
    }

    return httpOptions;
  }

  comboMonthYear(dateDe: Date, numberMonths: number, fomartoValue: string = 'YYYYMM', formatoLabel: string = 'YYYYMM'): Array<PoComboOption>{
    const momentDe = moment(dateDe);
    momentDe.locale('pt-br');
    const combo: Array<PoComboOption> = [{value: momentDe.format(fomartoValue), label: momentDe.format(formatoLabel)}];
    for (let count = 1; count < numberMonths; count++) {
      combo.push({value: momentDe.add(1, 'month').format(fomartoValue), label: momentDe.format(formatoLabel)})
    };
    return combo;
  }

  comboMonthYearRegresivo( numberMonths: number, fomartoValue: string = 'YYYYMM', formatoLabel: string = 'YYYYMM'): Array<PoComboOption>{
    const momentDe = moment(new Date());
    momentDe.locale('pt-br');
    const combo: Array<PoComboOption> = [{value: momentDe.format(fomartoValue), label: momentDe.format(formatoLabel)}];
    for (let count = 1; count < numberMonths; count++) {
      combo.push({value: momentDe.add(-1, 'month').format(fomartoValue), label: momentDe.format(formatoLabel)})
    };
    return combo;
  }

  comboMonthYearBetweenDates(dateDe: Date, dateAte: Date): Array<PoComboOption>{
    const momentDe = moment(dateDe);
    momentDe.locale('pt-br');
    const momentAte = moment(dateAte);
    momentAte.locale('pt-br');
    const combo: Array<PoComboOption> = [{value: momentDe.format('YYYYMM'), label: momentDe.format('MMMM/YYYY')}];
    for (let count = 1; count < momentAte.diff(momentDe, 'month', false); count++) {
      combo.push({value: momentDe.add(1, 'month').format('YYYYMM'), label: momentDe.format('MMMM/YYYY')})
    };
    return combo;
  }

  showErrosFomulario(formField: NgForm, document: Document): void{

    let campos = formField.controls;
    let mensagem: string;

    Object.keys(campos).some(key => {

      let erros = campos[key].errors;

      if (erros){

        Object.keys(erros).some(erro => {

          let campo = ''
          //@ts-ignore
          if (document.getElementsByName(key)[0].attributes['p-label']){
            //@ts-ignore
            campo = document.getElementsByName(key)[0].attributes['p-label'].nodeValue
          } else {
            campo = key
          }

          if (erro === 'required'){
            mensagem = `O campo ${campo} é obrigatório e não está preenchido.`;
          }else if (erro === 'min'){
            mensagem = `O valor do campo ${campo} (${campos[key].value}) é inferior ao valor MÍNIMO permitido.`
          }else if (erro === 'max'){
            mensagem = `O valor do campo ${campo} (${campos[key].value}) é superior ao valor MÁXIMO permitido.`
          }else if (erro === 'minlength'){
            mensagem = `A quantidade de caracteres do campo ${campo} (${campos[key].value.length}) é inferior ao Tamanho MÍNIMO de Caracteres permitidos.`
          }else if (erro === 'maxlength'){
            mensagem = `A quantidade de caracteres do campo ${campo} (${campos[key].value.length}) é superior ao Tamanho MÁXIMO de Caracteres permitidos.`
          } else {
            mensagem = `O valor do campo ${campo} não atende aos requisitos.`
          }

          this.poNotificationService.warning({
            message: mensagem,
            duration: 5000,
          })

        })
      }
    })
  }

  addBusinessDays(date: Date, diasUteis: number): Date {
    date = new Date(date.getTime());
    var day = date.getDay();
    date.setDate(date.getDate() + diasUteis + (day === 6 ? 2 : +!day) + (Math.floor((diasUteis - 1 + (day % 6 || 1)) / 5) * 2));
    return date;
  }

  formataHora(hora: number, comSegundos: boolean = false) {

    let msDuration = hora*3600000;
    const h = Math.floor(msDuration / 1000 / 60 / 60);
    const m = Math.floor((msDuration / 1000 / 60 / 60 - h) * 60);
    const s = Math.floor(((msDuration / 1000 / 60 / 60 - h) * 60 - m) * 60);

    // To get time format 00:00:00
    const seconds: string = s < 10 ? `0${s}` : `${s}`;
    const minutes: string = m < 10 ? `0${m}` : `${m}`;
    const hours: string = h < 10 ? `0${h}` : `${h}`;
    if (comSegundos){
      return `${hours}:${minutes}:${seconds}`;
    } else {
      return `${hours}:${minutes}`;
    }
  }

  showErrorResponse(message: string, e: HttpErrorResponse): void{
    this.poNotificationService.warning({
      message: message,
      actionLabel: 'Detalhe',
      action: () => {
        this.poDialogService.alert({
          title: `Code Error ${e.error.code}`,
          message: e.error.message,
         });
      },
      duration: 5000,
    })
  }

  formataData(data: string): string {
    return `${data.substring(8,10)}/${data.substring(5,7)}/${data.substring(0,4)}`;
  }

}
